import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppFab from "@/components/WhatsAppFab";
import LiveBookingToast from "@/components/LiveBookingToast";
import ClientOnly from "@/components/ClientOnly";
import Home from "@/pages/Home";
import DestinationDetail from "@/pages/DestinationDetail";
import DestinationsIndex from "@/pages/DestinationsIndex";
import Mice from "@/pages/Mice";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Inquiry from "@/pages/Inquiry";
import QuoteChat from "@/pages/QuoteChat";
import Admin from "@/pages/Admin";
import DubaiDmc from "@/pages/DubaiDmc";
import SingaporeDmc from "@/pages/SingaporeDmc";
import MalaysiaDmc from "@/pages/MalaysiaDmc";
import ThailandDmc from "@/pages/ThailandDmc";
import HongKongDmc from "@/pages/HongKongDmc";
import VietnamDmc from "@/pages/VietnamDmc";
import PhilippinesDmc from "@/pages/PhilippinesDmc";
import CambodiaDmc from "@/pages/CambodiaDmc";
import BaliDmc from "@/pages/BaliDmc";
import LaosDmc from "@/pages/LaosDmc";
import JapanDmc from "@/pages/JapanDmc";
import MiceServices from "@/pages/MiceServices";
import IncentiveTravel from "@/pages/IncentiveTravel";
import CorporateTravel from "@/pages/CorporateTravel";
import Blog from "@/pages/Blog";
import BlogWhatIsADmc from "@/pages/blog/WhatIsADmc";
import BlogTopIncentiveDestinations from "@/pages/blog/TopIncentiveDestinations";
import CaseStudy1800Dubai from "@/pages/blog/CaseStudy1800Dubai";
import CaseStudySingaporeIncentive from "@/pages/blog/CaseStudySingaporeIncentive";
import CaseStudyBaliLaunch from "@/pages/blog/CaseStudyBaliLaunch";
import MiceAsiaTrends2026 from "@/pages/blog/MiceAsiaTrends2026";
import HowToWriteMiceRfp from "@/pages/blog/HowToWriteMiceRfp";
import CaseStudiesLeadMagnet from "@/pages/CaseStudiesLeadMagnet";
import AsiaDmc from "@/pages/AsiaDmc";

export default function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/destinations" element={<DestinationsIndex />} />
              <Route path="/destinations/:slug" element={<DestinationDetail />} />
              <Route path="/mice" element={<Mice />} />
              <Route path="/mice-services" element={<MiceServices />} />
              <Route path="/dubai-dmc" element={<DubaiDmc />} />
              <Route path="/singapore-dmc" element={<SingaporeDmc />} />
              <Route path="/malaysia-dmc" element={<MalaysiaDmc />} />
              <Route path="/thailand-dmc" element={<ThailandDmc />} />
              <Route path="/hong-kong-dmc" element={<HongKongDmc />} />
              <Route path="/vietnam-dmc" element={<VietnamDmc />} />
              <Route path="/philippines-dmc" element={<PhilippinesDmc />} />
              <Route path="/cambodia-dmc" element={<CambodiaDmc />} />
              <Route path="/bali-dmc" element={<BaliDmc />} />
              <Route path="/laos-dmc" element={<LaosDmc />} />
              <Route path="/japan-dmc" element={<JapanDmc />} />
              <Route path="/incentive-travel" element={<IncentiveTravel />} />
              <Route path="/corporate-travel" element={<CorporateTravel />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/what-is-a-destination-management-company" element={<BlogWhatIsADmc />} />
              <Route path="/blog/top-incentive-travel-destinations-southeast-asia" element={<BlogTopIncentiveDestinations />} />
              <Route path="/blog/case-study-1800-pax-dubai-corporate-conference" element={<CaseStudy1800Dubai />} />
              <Route path="/blog/case-study-singapore-360-pax-incentive-trip" element={<CaseStudySingaporeIncentive />} />
              <Route path="/blog/case-study-bali-350-pax-channel-partner-launch" element={<CaseStudyBaliLaunch />} />
              <Route path="/blog/mice-asia-trends-2026" element={<MiceAsiaTrends2026 />} />
              <Route path="/blog/how-to-write-mice-rfp-asia" element={<HowToWriteMiceRfp />} />
              <Route path="/mice-case-studies-2025" element={<CaseStudiesLeadMagnet />} />
              <Route path="/destinations/asia-dmc" element={<AsiaDmc />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/inquiry" element={<Inquiry />} />
              <Route path="/quote" element={<QuoteChat />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <ClientOnly>
            <ChatWidget />
            <WhatsAppFab />
            <LiveBookingToast />
            <Toaster position="top-right" richColors />
          </ClientOnly>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}
